<script setup lang="ts">
  import { computed } from "vue";
  import { Text, IconChevronRight } from "@ui-kit";

  const { count } = defineProps<{ count: number }>();

  const is_error = computed(() => count > 0);
</script>

<template>
  <div class="items-without-zone" :class="{ error: is_error }" data-testid="check-binding-items-without-zone">
    <div class="items-without-zone__content">
      <Text font="body-regular-14" :color="is_error ? 'error' : 'primary'">{{ $t("Непривязанные цветомодели") }}</Text>
      <Text :color="is_error ? 'error' : 'primary'" data-testid="items-without-zone-count">{{ count }}</Text>
    </div>
    <IconChevronRight
      :style="{ width: '32px', height: '32px', stroke: is_error ? 'var(--sf-base-icon-error)' : undefined }"
    />
  </div>
</template>

<style scoped>
  .items-without-zone {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    background-color: var(--sf-base-background-secondary);
    padding: 16px;
    border-radius: 16px;
  }

  .items-without-zone__content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;

    & :deep(.text:last-of-type) {
      font-weight: 580;
      font-size: 32px;
      line-height: 42px;
      letter-spacing: 0;
    }
  }
</style>
